var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCorrect = function SvgCorrect(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.802 7.019a4.121 4.121 0 0 0-5.785 0l-25.95 25.676L6.983 22.72a4.122 4.122 0 0 0-5.786 0 4.018 4.018 0 0 0 0 5.725l12.975 12.838 2.893 2.862 2.893-2.862 28.843-28.539a4.017 4.017 0 0 0 0-5.724",
    fillRule: "evenodd"
  })));
};
export default SvgCorrect;